module.exports = __webpack_public_path__ + "static/media/contacts-icon.71d65e73.svg";